import React, { useState, useEffect, useImperativeHandle, forwardRef, useContext } from 'react';
import { useSelector } from 'react-redux';
import useQueries from '../../../../database/useQueries';
import { useIndexedDBSyncV2 } from '../../../../database/dataLocal/indexedDBHooks';
import LoadingOverlay from '../../pagesMains/LoadingOverlay';
import { formatPriceIL } from '../../plagins/data/commponentOptions';
import PaymentsManagement from '../../pagesCreate/paymentsManagementCreate';
import { createFetchDataServer, getTableData } from '../../../../database/fetchData';
import { DataContext } from '../../pagesMains/GravesManagers/Graves';
import { GlobalContext } from '../../../../App';

// function PurchaseUpdatePayments({ value, grave, handleClose }) {
const PurchaseUpdatePayments = forwardRef(({ value, grave, handleClose }, ref) => {
  // קבלת ערכים מהסטור
  const columns = useSelector((state) => state.columnsFormPurchases.data);

  // טעינת היוזים לפונקציות עזר
  const { getEntityByAttr, addOrUpdateDataPurchase } = useQueries();

  const { token } = useContext(GlobalContext);
  const context = useContext(DataContext);
  const fetchDataServer = createFetchDataServer(context);

  // איזור המשתנים והסטייטים
  // משתנים לטופס
  const [formValues, setFormValues] = useState({}); // ערכי השדות
  // עוקב אחר שליחת נתונים לשרת דרך פונקציית סבמיט
  const [loadingData, setLoadingData] = useState(false);
  const [loading, setLoading] = useState(false);

  // משתנים לערכי סלקט של השדות
  const [totalPrice, setTotalPrice] = useState(0);
  const [tempPayments, setTempPayments] = useState([]);
  const [defaultPayments, setDefaultPayments] = useState([]);

  // פונקציה לטעינת השדות מתוך הסטור

  const myColumns = (localColumns = null) => {
    localColumns = localColumns !== null ? localColumns : columns;
    return localColumns.map((field, index) => {
      let lock = false;
      lock = field.name !== 'paymentsList' && field.name !== 'numOfPayments' ? true : false;
      return {
        ...field,
        disabled: lock ? lock : field.disabled && grave !== undefined,
        required: field.name === 'spouse' && formValues.maritalStatus === 2 ? true : field.required || false,
        show: field?.show || false
      };
    });
  };

  // פעולות המתבצעות רק לאחר קבלת דאטה בייס ווליו מהראוטר
  useEffect(() => {
    !loading && handleAllDataLoaded();
  }, [loading]);

  // טעינת הנתונים לאחר קבלת הערכים מהדאטה בייס הלוקלי
  const handleAllDataLoaded = () => {
    if (value?.unicId) {
      const purchase = getEntityByAttr(context?.contextPurchases, 'unicId', value?.unicId);
      const grave = getEntityByAttr(context?.contextGraves, 'unicId', purchase?.graveId);

      let initialFormValues = myColumns()
        .filter((field) => field?.name)
        .reduce(
          (acc, field) => {
            let fieldValue = purchase[field.name] || '';
            // if (field.name === 'price') {
            //   setTotalPrice(purchase[field.name]);
            //   fieldValue = formatPriceIL(purchase[field.name]);
            // }
            if (field.name === 'paymentsList') {
              console.log(JSON.parse(purchase[field.name]));
              
              setDefaultPayments(JSON.parse(purchase[field.name]));
              fieldValue = purchase[field.name]
            }
            return {
              ...acc,
              [field.name]: fieldValue
            };
          },
          {
            id: purchase?.unicId
          }
        );

        console.log(initialFormValues);

      let res = fieldAuto(grave, purchase, initialFormValues);

      setFormValues(res);
    }
  };

  // טעינת ערכים אוטומטית לשדות
  const fieldAuto = (grave, purchase, newFormValues) => {
    const areaGrave = getEntityByAttr(context?.contextAreaGraves, 'gravesList', grave?.areaGraveId);
    const line = getEntityByAttr(context?.contextRows, 'unicId', areaGrave?.lineId);
    const plot = getEntityByAttr(context?.contextPlots, 'unicId', line?.plotId);
    const block = getEntityByAttr(context?.contextBlocks, 'unicId', plot?.blockId);

    const cemeteryId = getEntityByAttr(context?.contextCemeteries, 'unicId', block?.cemeteryId)?.unicId;
    const blockId = block?.unicId;
    const plotId = plot?.unicId;
    const lineId = line?.unicId;
    const areaGraveId = areaGrave?.unicId;
    const graveId = grave?.unicId;

    newFormValues = {
      ...newFormValues,
      cemeteryId,
      blockId,
      plotId,
      lineId,
      areaGraveId,
      graveId
    };

    setDefaultPayments(JSON.parse(purchase?.paymentsList));

    setTotalPrice(totalPrice);
    newFormValues = {
      ...newFormValues,
      price: purchase?.price,
      paymentsList: purchase?.paymentsList
    };

    return newFormValues;
  };

  const handlePaymentsChange = (payments) => {
    setTempPayments(payments);
  };

  const handleAnswerOk = (answer) => {
    setLoadingData(true);
  
    async function executeQueries(newFormValues) {
      try {
        setLoadingData(true);

        // שליחת הנתונים לשרת בפנייה אחת
        let res = await addOrUpdateDataPurchase(newFormValues);

        // בדיקת התוצאה
        if (res === 200) {
          // פעולות לאחר הצלחה
          setLoadingData(false);
        } else {
          // טיפול במקרה של כישלון
          console.error('השאילתה נכשלה');
          setLoadingData(false);
        }
      } catch (error) {
        console.error('שגיאה בביצוע השאילתות:', error);
        setLoadingData(false);
      } finally {
        return true;
      }
    }

    // ----------------------------------------------------

    if (answer) {

      let totalPrice = 0;

      tempPayments.forEach((pay) => {
        totalPrice += parseInt(pay.paymentAmount);
      });



      let newFormValues = {
        ...formValues,
        unicId: value?.unicId,
        price: totalPrice,
        paymentsList: JSON.stringify(tempPayments)
      };

      delete newFormValues?.cemeteryId;
      delete newFormValues?.blockId;
      delete newFormValues?.plotId;
      delete newFormValues?.lineId;
      delete newFormValues?.areaGraveId;  

      executeQueries(newFormValues);
    }
  };

  // השתמש ב- useImperativeHandle כדי לחשוף את handleAnswerOk
  useImperativeHandle(ref, () => ({
    handleAnswerOk
  }));

    useEffect(() => {
      async function loadTableData() {
        const localTempData = await getTableData('myDatabase', 'myStore');
        if (localTempData) {
          const dataCemeteries = localTempData.find((item) => item.name === 'dataCemeteries');
          const dataBlocks = localTempData.find((item) => item.name === 'dataBlocks');
          const dataPlots = localTempData.find((item) => item.name === 'dataPlots');
          const dataRows = localTempData.find((item) => item.name === 'dataRows');
          const dataAreaGraves = localTempData.find((item) => item.name === 'dataAreaGraves');
          const dataGraves = localTempData.find((item) => item.name === 'dataGraves');
          const dataPurchases = localTempData.find((item) => item.name === 'dataPurchases');
          const dataBurials = localTempData.find((item) => item.name === 'dataBurials');
          if (dataCemeteries && dataBlocks && dataPlots && dataRows && dataAreaGraves && dataGraves && dataPurchases && dataBurials) {
            setLoading(false);
          }
        }
  
        fetchDataServer(['purchases', 'burials'], token);
      }
      loadTableData();
    }, []);

  if ((loading || loadingData) && defaultPayments?.length === 0) {
    return <LoadingOverlay />;
  }

  return (
    <>
      {defaultPayments?.length > 0 && <PaymentsManagement defaultPayments={defaultPayments} onPaymentsChange={handlePaymentsChange} />}
      <p>
        <span
          style={{
            fontFamily: "'Courier New', Courier, monospace"
          }}>
          עדכון mini רכישה
        </span>
      </p>
    </>
  );
});

export default PurchaseUpdatePayments;
